import React, { useMemo, useEffect } from 'react';
import moment from 'moment';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import { getValidCountriesWhenRegionsOptionsUpdate } from '@intelligence/utils/regionSelectUtils';
import {
  // 时间筛选器的key
  RANGE_TIME as FILTER_RANGE_TIME,
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 组合下拉筛选器的key
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getIsMonthlyRank, getCountriesValues } from '../../../utils';
import {
  CONSOLE_PLATFORM_PLAYSTATION,
  CONSOLE_PLATFORM_NINTENDO,
  CONSOLE_TOP_BEST_SELLING,
  CONSOLE_TOP_FREE_TO_PLAY,
} from '@/pages/intelligence/_config/storeRank/config';
import { TYPES_MAPPING } from '@/pages/intelligence/components/ComposedCountrySelect/constants';

import type { IDateTypely, IRegion } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsFilter } from '../../../types';

const getDateTypely = (granularity: IDateTypely, cfg: { isMonthlyRank: boolean; top: string }): IDateTypely => {
  const { isMonthlyRank, top } = cfg ?? {};
  if (top === CONSOLE_TOP_FREE_TO_PLAY) return granularity;
  return isMonthlyRank ? 'monthly' : 'daily';
};

// 更新时间， platform-top 筛选器的value
export default function useUpdateFiltersFormValue(props: {
  isOperate: boolean;
  filter: IStoreRankDetailsFilter;
  regionsOptions: IRegion[];
  regionsOptionsMap: { [key: string]: IRegion[] };
  formValue: any;
  setFormValue: any;
}) {
  const { isOperate, filter, regionsOptions, regionsOptionsMap, formValue, setFormValue } = props ?? {};

  const isMonthlyRank = useMemo<boolean>(() => {
    const platform = filter?.platform ?? CONSOLE_PLATFORM_PLAYSTATION;
    const top = filter?.top ?? CONSOLE_TOP_BEST_SELLING;
    const granularity = filter?.granularity ?? 'daily';
    return getIsMonthlyRank({ platform, top, granularity });
  }, [filter?.platform, filter?.top, filter?.granularity]);

  // 更新时间筛选器的value
  useEffect(() => {
    const dateTypely = getDateTypely(filter?.granularity, { isMonthlyRank, top: filter?.top });
    const dateType = feachTimeTypeToFilterTimeType(dateTypely) ?? 'date';
    const dateValue = [moment(filter?.start_date), moment(filter?.end_date)];
    setFormValue({
      ...formValue,
      [FILTER_RANGE_TIME]: {
        type: dateType,
        value: dateValue,
      },
      // [FILTER_COMPOSED_SELECT]: {
      //   value: {
      //     parent: filter?.platform ?? CONSOLE_PLATFORM_PLAYSTATION,
      //     child: filter?.top ?? CONSOLE_TOP_BEST_SELLING,
      //   },
      // }
    })
  }, [isMonthlyRank, filter?.top, filter?.granularity, filter?.start_date, filter?.end_date, filter?.platform, filter?.top]);


  // 更新单选、多选国家筛选器的value
  // useEffect(() => {
  //   if (isOperate) return;
  //   if (isMonthlyRank) return;
  //   const isNintendo = filter?.platform === CONSOLE_PLATFORM_NINTENDO;
  //   const composedSelectValue = formValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
  //   const countriesTypeTmp = isNintendo ? 'single' : composedSelectValue?.type ?? 'multiple';
  //   const regionsOptions = regionsOptionsMap?.[filter?.platform];
  //   const optionsValues = getCountriesValues(regionsOptions);
  //   let countriesTmp: string[] = [];
  //   if (countriesTypeTmp === 'single') {
  //     const currentSingleCountry = formValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value?.countries?.[0];
  //     countriesTmp = optionsValues?.includes(currentSingleCountry)
  //       ? [currentSingleCountry] :
  //       optionsValues?.includes('us')
  //         ? ['us']
  //         : optionsValues?.slice(0, 1);
  //   } else if (countriesTypeTmp === 'multiple') {
  //     countriesTmp = optionsValues ?? [];
  //   }
  //   setFormValue({
  //     ...formValue,
  //     [FILTER_COMPOSED_COUNTRY_SELECT]: {
  //       value: {
  //         type: countriesTypeTmp,
  //         countries: countriesTmp,
  //       },
  //     }
  //   })
  // }, [isOperate, isMonthlyRank, filter?.platform, filter?.top, regionsOptionsMap]);

  useEffect(() => {
    if (isOperate) return;
    if (isMonthlyRank) return;
    const isNintendo = filter?.platform === CONSOLE_PLATFORM_NINTENDO;
    const composedSelectValue = formValue?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
    const composedCountriesTypeTmp = isNintendo ? 'single' : composedSelectValue?.type || 'multiple';
    let composedCountriesTmp = composedSelectValue?.countries || [];
    const nextRegionsOptions = regionsOptionsMap?.[filter?.platform];
    composedCountriesTmp = getValidCountriesWhenRegionsOptionsUpdate({
      type: composedCountriesTypeTmp,
      countries: composedCountriesTmp,
      regions: regionsOptions,
      nextRegions: nextRegionsOptions,
    });
    setFormValue({
      ...formValue,
      [FILTER_COMPOSED_COUNTRY_SELECT]: {
        value: {
          type: composedCountriesTypeTmp,
          countries: composedCountriesTmp,
        },
      },
    });
  }, [isOperate, isMonthlyRank, filter?.platform, filter?.top, regionsOptions, regionsOptionsMap]);
}
